var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var getSlug = require('speakingurl');
var ContentEditor = require( './editor.jsx' );

var EducationEditor = createReactClass( {
    getInitialState: function () {
        return {
          addTopic: false,
        };
    },

    componentDidMount: function(){
        new Foundation.Accordion($("#educationList"), { allowAllClosed: true });
    },

    componentDidUpdate: function(nextProps){
        Foundation.reInit($("#educationList"));
    },

    handleChange: function(e, topicNum, sectionNum = null) {
        const { education } = this.props;
        const editedTopic = education[topicNum];

        if (sectionNum !== null) {
            const editedSection = editedTopic.sections[sectionNum];
            editedSection[e.target.name] = e.target.value;
            editedTopic.sections[sectionNum] = editedSection;
        } else {
            if (e.target.name === 'title') {
                // If title edit, duplicate slug into topic field
                editedTopic.topic = getSlug(e.target.value);
            }
            editedTopic[e.target.name] = e.target.value;
        }

        education[topicNum] = editedTopic;
        this.props.setEducation(education);
    },

    handleEditorChange: function(topicNum, sectionNum, content) {
        const { education } = this.props;
        const editedTopic = education[topicNum];
        const editedSection = editedTopic.sections[sectionNum];

        if (content) {
            editedSection.format = 'html';
            editedSection.content = content;
        }

        // Reassemble education object
        editedTopic.sections[sectionNum] = editedSection;
        education[topicNum] = editedTopic;

        this.props.setEducation(education);
    },

    handleAddTopic: function(event) {
        const { education } = this.props;
        // const title = this.refs.topicTitle.value.trim();
        const newTopic = {
            title: "New topic",
            topic: "new-topic",
            sections: [{ visible: true, format: 'html', title: '', content: '' }]
        }
        education.push(newTopic);
        this.props.setEducation(education);
    },

    handleDeleteTopic: function(topicNum) {
        const { education } = this.props;
        education.splice(topicNum, 1);

        $('#educationList').foundation('up', $('#educationList .accordion-content'));
        this.props.setEducation(education);
    },

	render: function () {
        const { education } = this.props;

        return (
            <div>
                <h3>
                    <span>Education topics</span>
                    <span className='float-right'>
                        <button className="hollow button small float-right" type="button" onClick={this.handleAddTopic}>+ Add new topic</button>
                    </span>
                </h3>
                <ul className="topic-list accordion no-bullet" data-accordion id="educationList">
                    {education.map((item, topicNum) => {
                        return (
                            <li className="accordion-item" data-accordion-item key={topicNum}>
                                <a className="accordion-title"><h4>{item.title}</h4></a>
                                <div className="accordion-content" data-tab-content>
                                    <div className="input-field">
                                        <label htmlFor="topic-title" className="heading">Topic area title</label>
                                        <input type="text" id="topic-title" name="title" defaultValue={item && item.title} onChange={(e) => this.handleChange(e, topicNum)} />
                                    </div>
                                    <hr />
                                    { item.sections.map((section, sectionNum) => {
                                        return (
                                            <div key={sectionNum}>
                                                <div className="input-field">
                                                    <label htmlFor="section-title" className="heading">Section title</label>
                                                    <input type="text" id="section-title" name="title" defaultValue={section.title} onChange={(e) => this.handleChange(e, topicNum, sectionNum)} />
                                                </div>
                                                <ContentEditor payload={section.content} name="content" onChange={(content) => this.handleEditorChange(topicNum, sectionNum, content)} />
                                                <hr />
                                            </div>
                                        );
                                    })}
                                    <br />
                                    <span className=''>
                                        <button
                                            className="hollow button small alert"
                                            type="button"
                                            onClick={() => { (window.confirm('Are you sure you wish to delete this entire topic?')) && this.handleDeleteTopic(topicNum) } }>Delete topic</button>
                                    </span>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
	}
});

module.exports = EducationEditor;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/educationEditor.jsx